const OwlShopSelectors = require("lib/selectors/OwlShopSelectors");
var Modal = require('components/utility/AltModal');
var CurrentUser = require('lib/account/CurrentUser');
var AvatarPatch = require('components/avatars/AvatarPatch')
var Tiers = require("lib/games/Tiers");
var OwlShopRouting = require("lib/routing/OwlShopRouting");


import { connect } from "react-redux";

require('games/golden_egg.scss');

@connect(
	(state, ownProps) => ({
        //get the patches that the user doesn't own
		filteredPatches: OwlShopSelectors.getFilteredPatches({ state }),
		filteredPerks: OwlShopSelectors.getFilteredPerks({ state }),
		allFurnitures:  OwlShopSelectors.getFurnitures({ state }),
		user: CurrentUser.get()
	}),
    null,
    null,         
    {forwardRef: true}
)

class GoldenEggModal extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        this.state = {
            eggOpen: false,
            awardType: null,
            awardDetails: null,
        };
    }

    show() {
        this.refs.modal.show();
    }

    hide() {
        this.refs.modal.hide();
    }

    
    // gets all unowned items at the current tier which the student can afford 
    getUnownedItems() {
        var reqs = Tiers.REQUIREMENTS[this.props.user.tier]  
        var currentTier = this.props.user.tier;
        var reqsRemaining = $wr.getRemainingReqs(currentTier, reqs, this.props.filteredPatches, this.props.filteredPerks, this.props.allFurnitures);
        var userCoins = this.props.user.coins; 
        var unownedPatches = _.select(this.props.filteredPatches, function(patch) {
            //removes duplicates by removing right hand and body 2 items
            var handType = patch.origin_patch_type == "hand" ? "left_hand" : patch.patch_type; 
            var bodyType = patch.origin_patch_type == "body" ? "body" : patch.patch_type;
            //adds field to identify item is a patch (vs perk or furniture)
            patch["category"] = "patch";
            return !patch.owned && patch.source == "store" && patch.tier == currentTier
            && (Object.keys(reqsRemaining).includes(patch.patch_type) || Object.keys(reqsRemaining).includes(patch.origin_patch_type))
            && (patch.patch_type == handType) && (patch.patch_type == bodyType);
        });

        var unownedPerks = _.select(this.props.filteredPerks, function(perk) {
            perk["category"] = "perk";
            return Object.keys(reqsRemaining).includes(perk.perk_type) || Object.keys(reqsRemaining).includes("total") 
            && perk.perk_type != "titles" && (!perk.owned && perk.source == "store" && perk.tier == currentTier)
        });

        var unownedFurniture = _.select(this.props.allFurnitures, function(furniture) {
            furniture["category"] = "furniture";
            //removes duplicates (wall items2 and floor items2)
            return !furniture.owned && furniture.source == "store" && furniture.tier == currentTier
            && Object.keys(reqsRemaining).includes(furniture.perk_type);
        });

        var coinAmount = this.state.awardCoinsDetails;

        var unownedItems = unownedPatches.concat(unownedPerks, unownedFurniture).filter(function(item) {
            return (item.price <= (userCoins + coinAmount));
        });
        return unownedItems;
    }  

    getAdjustedFurnitureType(furnitureType) {
		if (furnitureType == "wall_items2") {
			return "wall_items";
		} else if (furnitureType == "floor_items2") {
			return "floor_items";
		}
		return furnitureType;
	}

    // renders the item with its picture, name, and link
    renderItem(item) {          
        var itemName = item.title || item.name 
        var path = ""
        if (item["category"] == "patch") {
            path = "patches/" + item["origin_patch_type"]
            + "/" + item["name"] + "-s.png";
            path = dynamicRequire(path);
        }

        else if (item["category"] == "perk") {
            if (item.perk_type == "backgrounds" || item.perk_type == "houses"
                || item.perk_type == "owl_hoots" || item.perk_type == "background_sounds"
                || item.perk_type == "greetings") {
               
               if (item.perk_type == "houses" || this.props.allFurnitures.indexOf(item.perk_type) >= 0) {
                   var name = item["name"].toLowerCase().replace(/\s/g, "-");
                   if (name.indexOf('\'') >= 0) {
                       name = name.replace('\'', "");
                   }
               } else {
                   var name = item["name"].toLowerCase().replace(/\s/g, "_")
               }
               var path = "perks/" + item["origin_perk_type"]
                   + "/" + name + ".png";
               path = dynamicRequire(path);
   
           } else if (this.props.allFurnitures.indexOf(item.perk_type) >= 0) {
               var path = "perks/" + item["origin_perk_type"]
                   + "/" + item["name"] + ".png";
               path = dynamicRequire(path);
           } 
        } 
        
        else {
            var adjustedFurnitureType = this.getAdjustedFurnitureType(item.perk_type);
		    var path = "furnitures/" + adjustedFurnitureType + "/" + item["name"] + ".png";
		    path = dynamicRequire(path)
        }

        var key = path

        return (
            <a key={key} href="#" onClick={() => this.redirectToOwlShopItem(item)}>
            <div className = "displayItem">
                <img src={ path } className="patchThumbnail"/>
                <br />
                <p className="title">{ itemName }</p>
            </div>
            </a>
        )
    }

    // gets three random items (still unowned, can afford, same tier as student)
    getRandomItems() {
        var unownedItems = this.getUnownedItems()
        var randomItems  = unownedItems.sort(() => .5 - Math.random()).slice(0, 3).map((item) => {
            return item
        });
        this.setState({randomItems: randomItems});
    }

    // redirects to preview the item in the owl shop
    redirectToOwlShopItem(item){
        var itemName = item.name
        if (item["category"] == "patch") {
            var itemType=item.patch_type+"&patch=true"
        } else {
            var itemType=item.perk_type
        }
        if (item["category"] == "furniture") {
            var params = "?itemName="+itemName+"&itemType="+itemType+"&furniture=true"
        } else {
            var params = "?itemName="+itemName+"&itemType="+itemType
        }
        $wr.redirect(OwlShopRouting.getPath({})+params )
    }

   
    
    handleOpen() {
        var params = { award: { type: "golden_egg", student_id: CurrentUser.get().id } };
        CurrentUser.api().postAwards(params, $wr.apiHandler ((response) => {
            setTimeout(() => {
                if (response && response.response && response.response.award && response.response.success) {
                    var responseData = response.response.award;
                    this.setState({ eggOpen: true, awardType: responseData["type"], awardPatchDetails: responseData["details"]["patch"], awardCoinsDetails: responseData["details"]["amount"] });
                    if (this.state.awardType == "coins") {
                        this.getRandomItems();
                    }
                } else {
                    if (this) { this.hide(); }
                }
                this.props.onComplete();
                CurrentUser.fetchCurrentUserData();
            }, 750)
        }));
    }

    renderCoinsAward() {
        var eggPath = require("goldenegg/egg-open-0.png");
        var awardImage = <img src={ require('official-icons/coin.png') } className="awardsCoin" />
        var coinAmount = this.state.awardCoinsDetails
        var awardName = <p className="coinAmount">You just got { coinAmount } coins!</p>
        var randomItems = this.state.randomItems
        // renders item pictures and names
        if (randomItems && randomItems.length > 0) {
            var displayItems = _.map(randomItems, function(item) {
            return this.renderItem(item);
            }.bind(this));
            var randomItemsDesc = <p className="patchDescription">To level up, you can now purchase:</p>
        }

        return (
                <div className="data">
                    { awardName }
                    <p className="awardImage">{ awardImage }</p>
                    <div className="eggContainer">
                        <img src={ eggPath } className="goldenEggInsideModal"  />
                    </div>
                    < br />
                    { randomItemsDesc }
                    <div>
                        <div className="itemsDisplay">
                            { displayItems }
                        </div>
                        <p className="owlShopLink">Visit the <a href = "/owl_shop">Owl Shop</a> to see more!</p>
                    </div>
                </div>
        );
    }

    renderPatchAward() {
        var eggPath = require("goldenegg/egg-open-0.png");
        var awardImagePath = "patches/" + this.state.awardPatchDetails["origin_patch_type"]
        + "/" + this.state.awardPatchDetails["name"] + "-s.png";
        var awardImage = <img src= { dynamicRequire(awardImagePath) } className="awardsPatch"/>
        var patchName = this.state.awardPatchDetails["title"]
        var patchDescription = this.state.awardPatchDetails["description"]
        var awardName = <p className="patchName">You just got a new patch:<br></br> { patchName }!</p>

        return (
                <div className="data">
                    { awardName }
                    <p className="patchDescription">{ patchDescription }</p>
                    <p className="awardImage">{ awardImage }</p>
                    <div className="eggContainer">
                        <img src={ eggPath } className="goldenEggInsideModal"  />
                    </div>
                    <br />
                    <div>
                    <p className="owlShopLink">Visit the <a href = "/owl_shop">Owl Shop</a> to see more!</p>
                    </div>
                </div>
        );
    }

    render() {
        if (this.state.eggOpen){
            if (this.state.awardType == "coins") {
               var eggModalContent = this.renderCoinsAward()
            }
            else {
                //var coinImage = <img src={ require('official-icons/coin-s.png') } className="awardsCoin" />
                var eggModalContent = this.renderPatchAward()
            }
        } else {
            var eggPath = require("goldenegg/egg-0.png");
        }
        return (
            <Modal className="eggModal" ref="modal" headerText="Golden Egg" onShow={this.handleOpen}>
            {eggModalContent}
            </Modal>
        );
    }
}



module.exports = GoldenEggModal;



// WEBPACK FOOTER //
// ./modules/components/games/GoldenEggModal.js